const PACKAGE_VERSION = "0.51.2";
const TARGETED_RPC_VERSION = "1.23.0";
export {
  PACKAGE_VERSION,
  TARGETED_RPC_VERSION
};
//# sourceMappingURL=version.js.map
